import React from 'react';
import { Stack, Chip } from '@mui/material';
import { SentimentSatisfiedAltOutlined as SentimentIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import TemperatureChip from '../../../components/TemperatureChip';
import {
  getTemperatureFromInsight,
  getTemperatureColorFromInsight,
} from '../../../components/TemperatureChip/temperature';
import { sentimentChipSx } from '../../../utils/sentiment';

const getSentimentLabel = (sentiment, t) => {
  if (sentiment > 0) return t('leadDetails.sentimentPositive');
  if (sentiment < 0) return t('leadDetails.sentimentNegative');
  return t('leadDetails.sentimentNeutral');
};

const ClientAiInsights = ({ aiInsights }) => {
  const { t } = useTranslation();
  if (!aiInsights) return null;

  const temperature = aiInsights.last_temperature;
  const hasTemperature = !!temperature;
  const hasSentiment = aiInsights.last_sentiment !== null && aiInsights.last_sentiment !== undefined;

  if (!hasTemperature && !hasSentiment) return null;

  return (
    <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap" sx={{ mb: 1.5 }}>
      {hasTemperature && (
        <TemperatureChip
          hasInsight
          temperatureValue={temperature}
          temperature={getTemperatureFromInsight(temperature)}
          temperatureColor={getTemperatureColorFromInsight(temperature)}
        />
      )}
      {hasSentiment && (
        <Chip
          icon={<SentimentIcon />}
          label={getSentimentLabel(aiInsights.last_sentiment, t)}
          size="small"
          sx={sentimentChipSx(aiInsights.last_sentiment)}
        />
      )}
    </Stack>
  );
};

export default ClientAiInsights;
